import React, { useState } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import axios from "axios";
import tractorImage from "../../assets/tractor.jpg";

const Login = () => {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    const BASE_AUTH_URL = process.env.REACT_APP_API_AUTH_BASE_URL;
    setLoading(true);
    try {
      const response = await axios.post(`${BASE_AUTH_URL}/login`, {
        email,
        password,
      });

      const { access_token, role, name } = response.data;

      // Store token and role (optional for use in other parts of the app)
      localStorage.setItem("token", access_token);
      localStorage.setItem("role", role);
      localStorage.setItem("name", name);

      alert("Login successful!");

      // Redirect based on role
      switch (role) {
        case "ADMIN":
          history.push("/dashboard");
          break;
        case "MANUFACTURER":
          history.push("/dashboard");
          break;
        case "DEALER":
          history.push("/dashboard");
          break;
        default:
          alert("Unknown role. Please contact support.");
      }
    } catch (error) {
      console.error("Login failed:", error);
      alert("Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      style={{
        backgroundImage: `url(${tractorImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Box
        bgcolor="white"
        padding={4}
        borderRadius={8}
        boxShadow="0px 2px 4px rgba(0, 0, 0, 0.1)"
        width="100%"
        maxWidth="400px"
      >
        <Typography variant="h5" gutterBottom>
          Login Now
        </Typography>

        <TextField
          label="Email"
          variant="outlined"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          margin="normal"
        />
        <TextField
          label="Password"
          type="password"
          variant="outlined"
          fullWidth
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          margin="normal"
        />

        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleLogin}
          disabled={loading}
          sx={{ mt: 2 }}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "LOGIN"}
        </Button>
      </Box>
    </Box>
  );
};

export default Login;
